import { useMemo } from "react";
import {
  buildRfiServiceFilterOptions,
  buildTemplateFilterOptions,
} from "../utils/catalogFilterOptions";

/**
 * Services dropdown: catalog RFIs narrowed to capabilities present on `allPagesItems`.
 */
export function useRfiServiceFilterOptions(catalogRfis, allPagesItems, isAllDataFetched) {
  return useMemo(
    () =>
      buildRfiServiceFilterOptions(catalogRfis, allPagesItems, isAllDataFetched),
    [catalogRfis, allPagesItems, isAllDataFetched]
  );
}

/**
 * My RFIs Templates dropdown: questionnaires narrowed to templates used in user's RFIs.
 */
export function useTemplateFilterOptionsFromMyRfis(
  questionnaires,
  allPagesRfiItems,
  isAllRfisFetched,
  mapToOption
) {
  return useMemo(
    () =>
      buildTemplateFilterOptions(
        questionnaires,
        allPagesRfiItems,
        isAllRfisFetched,
        mapToOption
      ),
    [questionnaires, allPagesRfiItems, isAllRfisFetched, mapToOption]
  );
}
